/**
 * Одна ячейка видеовизитки / портрета разработчика.
 */

import { useRef } from "react";

function TeamCard({ member }) {
    const videoRef = useRef(null);
    const hasVideo = Boolean(member.video);
    const hasPhoto = Boolean(member.photo);

    const playVideo = () => {
        const video = videoRef.current;
        if (!video) return;
        video.play().catch((error) => {
            console.warn("Team card video play skipped", { id: member.id, error: error.message });
        });
    };

    const stopVideo = () => {
        const video = videoRef.current;
        if (!video) return;
        video.pause();
        video.currentTime = 0;
    };

    const toggleVideo = () => {
        const video = videoRef.current;
        if (!video) return;
        if (video.paused) playVideo();
        else stopVideo();
    };

    return (
        <article className="team-card">
            <div
                className={`team-card__media${hasVideo ? " team-card__media_video" : ""}`}
                onMouseEnter={hasVideo ? playVideo : undefined}
                onMouseLeave={hasVideo ? stopVideo : undefined}
                onClick={hasVideo ? toggleVideo : undefined}
            >
                {hasVideo ? (
                    <video
                        ref={videoRef}
                        className="team-card__video"
                        src={member.video}
                        poster={member.photo || undefined}
                        muted
                        loop
                        playsInline
                        preload="metadata"
                    />
                ) : hasPhoto ? (
                    <img className="team-card__photo" src={member.photo} alt={member.name || "Developer portrait"} />
                ) : (
                    <div className="team-card__empty" aria-hidden="true">
                        <svg className="team-card__silhouette" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="40" cy="28" r="14" fill="#C5C9DE" />
                            <path d="M16 70c0-13.255 10.745-24 24-24s24 10.745 24 24" fill="#C5C9DE" />
                        </svg>
                    </div>
                )}
                {hasVideo && (
                    <span className="team-card__play" aria-hidden="true">
                        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                            <path d="M8 5.5v13l11-6.5-11-6.5z" />
                        </svg>
                    </span>
                )}
            </div>
            <div className="team-card__meta">
                <p className="team-card__name">{member.name || "Name"}</p>
                {member.role ? <p className="team-card__role">{member.role}</p> : null}
            </div>
        </article>
    );
}

export default TeamCard;
// components/TeamCards/TeamCard.js
